import React, { useState, useImperativeHandle, forwardRef } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ImgStepTwo from "../../../../../assets/Images/CarePlan2A.jpg";
import DiagnosisModal from "../modals/AddDiagnosisModal";

function DiagnosesComponent({ setStandardCarePlanIds }, ref) {
  const { t } = useTranslation();
  const [diagnoses, setDiagnoses] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  // Expone la función resetDiagnoses al padre mediante el ref
  useImperativeHandle(ref, () => ({
    resetDiagnoses: () => {
      setDiagnoses([]);
      setStandardCarePlanIds([]);
      console.log("🔄 Diagnósticos limpiados desde ref");
    },
  }));

  const handleSaveDiagnosis = (newDiagnosis) => {
    setDiagnoses((prev) => [...prev, newDiagnosis]);
    if (newDiagnosis.standardCarePlanId) {
      setStandardCarePlanIds((prev) => [...prev, newDiagnosis.standardCarePlanId]);
    }
  };

  const handleRemoveDiagnosis = (id) => {
    setDiagnoses((prev) => prev.filter((diag) => diag.id !== id));
  };

  return (
    <Box sx={{ backgroundColor: "#fff", borderRadius: 2, boxShadow: 3, overflow: "hidden", width: "100%" }}>
      {/* Header */}
      <Box sx={{ backgroundColor: "#085394", display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }}>
        <Box sx={{ backgroundColor: "#fff", borderRadius: 1, px: 2, py: 1, display: "inline-block" }}>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#085394", textTransform: "uppercase", m: 0 }}>
            {t("CarePlan.createCarePlanHdr.wizard.stepTwo")}
          </Typography>
        </Box>
        <Box sx={{ ml: 2 }}>
          <img src={ImgStepTwo} alt="Diagnóstico" style={{ width: "120px", borderRadius: "8px" }} />
        </Box>
      </Box>

      {/* Tabla y Botón */}
      <Box sx={{ p: 3 }}>
        <TableContainer component={Paper} sx={{ mb: 3, boxShadow: 3 }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#085394" }}>
              <TableRow>
                {["diagnostic", "diagnosticType", "action"].map((key) => (
                  <TableCell key={key} sx={{ color: "#fff", fontWeight: "bold" }}>
                    {t(`CarePlan.diagnosis.table.${key}`)}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {diagnoses.length > 0 ? (
                diagnoses.map((diag) => (
                  <TableRow key={diag.id}>
                    <TableCell>{diag.name}</TableCell>
                    <TableCell>{diag.type}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleRemoveDiagnosis(diag.id)} sx={{ color: "red", "&:hover": { backgroundColor: "#FFEBEE" } }}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    {t("CarePlan.diagnosis.noRecords")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpenModal(true)}
          sx={{ backgroundColor: "#085394", "&:hover": { backgroundColor: "#064372" } }}
        >
          {t("CarePlan.diagnosis.addDiagnosis")}
        </Button>
      </Box>

      <DiagnosisModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onSave={handleSaveDiagnosis}
      />
    </Box>
  );
}

export default forwardRef(DiagnosesComponent);
